import { useLocation } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();

  // Determine title based on pathname
  const getTitle = (pathname) => {
    switch (pathname) {
      case "/users":
        return "All Users";
      case "/":
        return "Dashboard";
      case "/domain-data":
        return "Domain Data";
      default:
        return "Admin Panel";
    }
  };

  return (
    <nav className="navbar navbar-light bg-light px-4">
      <span className="navbar-brand mb-0 h1">
        {getTitle(location.pathname)}
      </span>
    </nav>
  );
};

export default Navbar;
